export default "__VITE_ASSET__DOE6$_6p__"